import { render, staticRenderFns } from "./previewTemplate.vue?vue&type=template&id=6224859e&scoped=true&"
import script from "./previewTemplate.vue?vue&type=script&lang=js&"
export * from "./previewTemplate.vue?vue&type=script&lang=js&"
import style0 from "./previewTemplate.vue?vue&type=style&index=0&id=6224859e&prod&lang=scss&"
import style1 from "./previewTemplate.vue?vue&type=style&index=1&id=6224859e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6224859e",
  null
  
)

export default component.exports